module.exports = __webpack_public_path__ + "static/media/renewrewards.2c4b73c6.png";